import { useMemo } from "react";
import { useApi, apiResolver } from "@/api/useApi";
import {
  Prerequisite,
  CreatePrerequisiteDto,
  UpdatePrerequisiteDto,
} from "./Prerequisite.model";

export function usePrerequisiteApi() {
  const { api } = useApi();

  return useMemo(
    () => ({
      createPrerequisite: async (input: CreatePrerequisiteDto) =>
        apiResolver<Prerequisite>(api.post("/platform/prerequisites", input)),
      updatePrerequisite: async (
        prerequisiteId: string,
        input: UpdatePrerequisiteDto
      ) =>
        apiResolver<Prerequisite>(
          api.put(`/platform/prerequisites/${prerequisiteId}`, input)
        ),
      deletePrerequisite: async (prerequisiteId: string) =>
        apiResolver<{ success: boolean }>(
          api.delete(`/platform/prerequisites/${prerequisiteId}`)
        ),
      getPrerequisite: async (prerequisiteId: string) =>
        apiResolver<Prerequisite | null>(
          api.get(`/platform/prerequisites/${prerequisiteId}`)
        ),
      getPrerequisites: async (topicReleasePolicyId?: string) =>
        apiResolver<Prerequisite[]>(
          api.get(
            `/platform/prerequisites${topicReleasePolicyId ? `?topicReleasePolicyId=${topicReleasePolicyId}` : ""}`
          )
        ),
    }),
    [api]
  );
}
